import CourseBuilderScreen from '@/features/unified-learning/screens/CourseBuilderScreen';

export default CourseBuilderScreen;
